import { render, staticRenderFns } from "./MemberEditForm.vue?vue&type=template&id=73b28621&"
import script from "./MemberEditForm.vue?vue&type=script&lang=js&"
export * from "./MemberEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports